<template>
	<div class="text-center">
		<v-btn color="primary" @click="dialog = true"> New District </v-btn>

		<v-dialog v-model="dialog" persistent width="auto">
			<v-card>
				<v-card-title>
					<span>New District</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-form ref="form" lazy-validation>
							<v-row>
								<v-col cols="12" sm="12" md="12">
									<v-text-field
										label="District name*"
										required
										v-model="district.district_name"
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6">
									<v-text-field
										v-model="district.firstname"
										label="First name*"
										required
										hint="Enter first name"
										:rules="[rules.required]"
										clearable
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6">
									<v-text-field
										v-model="district.lastname"
										label="Last name*"
										hint="Enter last name"
										clearable
										required
										:rules="[rules.required]"
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6">
									<v-text-field
										label="Email*"
										v-model="district.email"
										:rules="[rules.required, rules.email]"
										required
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6">
									<v-text-field
										label="Phone*"
										v-model="district.phone"
										required
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="12">
									<v-select
										v-model="district.timezone"
										:items="timeZones"
										item-text="text"
										item-value="value"
										label="Time Zone*"
										:rules="[rules.required]"
									></v-select>
								</v-col>
							</v-row>
							<!-- Hidden field for add_district_school -->
							<input type="hidden" v-model="district.district" />
						</v-form>
					</v-container>
					<small>*indicates required field</small>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" variant="flat" @click="validate(district)">Save</v-btn>
					<v-btn color="primary" variant="outlined" @click="dialog = false">Cancel</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.v-card-title {
	background-color: $primary;
	color: white;
}
</style>
<script setup lang="ts">
// import Autocomplete from "@/components/autocomplete.vue";
import type { NewDistrict } from "@/api_types/school";
import { useAlertsStore } from "@/stores/alerts";
import useSchools from "@/stores/support/schools";
import { ref } from "vue";

const district = ref<NewDistrict>({
	district_name: "",
	firstname: "",
	lastname: "",
	email: "",
	phone: "",
	timezone: "",
	district: true,
});
const alertStore = useAlertsStore();
const schoolStore = useSchools();
const form = ref();
const dialog = ref(false);
const usZones = [
	{ CountryCode: "US", Timezone: "America/New_York", Description: "Eastern Time" },
	{ CountryCode: "US", Timezone: "America/Chicago", Description: "Central Time" },
	{ CountryCode: "US", Timezone: "America/Denver", Description: "Mountain Time" },
	{ CountryCode: "US", Timezone: "America/Los_Angeles", Description: "Pacific Time" },
	{ CountryCode: "US", Timezone: "America/Anchorage", Description: "Alaska Time" },
	{ CountryCode: "US", Timezone: "Pacific/Honolulu", Description: "Hawaii Time" },
];

const timeZones = ref(usZones.map((zone) => zone.Timezone));
const rules = {
	required: (value) => !!value || "Field is required",
	email: (value) => /.+@.+/.test(value) || "Invalid email address",
	number: (value) => (!isNaN(parseFloat(value)) && isFinite(value)) || "Must be a number",
};
const createDistrict = async function (district: NewDistrict) {
	console.log("Creating trial");
	const res = await schoolStore.createDistrict(district);
	console.log(res);
	if (res.status) {
		alertStore.addAlert("success", "New Trial Created", 5);
	} else {
		alertStore.addAlert("error", res.message, 10);
	}
	dialog.value = false;
	// console.log(trial);
};
const validate = async (district: NewDistrict) => {
	const { valid } = await form.value.validate();
	if (valid) {
		createDistrict(district);
	} else {
		console.log("invalid form");
	}
};
</script>
